module.exports = __webpack_public_path__ + "img/c05_unittechequeschampion_Normal_ua.af45f626.webp";